import React, { createContext, useContext, useState } from "react";

const dict = {
  id: {
    "app.name": "Nusacert CRM",
    "app.tagline": "Manajemen Penjualan ISO",
    "nav.dashboard": "Dasbor",
    "nav.pipeline": "Pipeline",
    "nav.forecast": "Forecast",
    "nav.contacts": "Kontak",
    "nav.leadsIdle": "Leads Idle",
    "nav.meetings": "Meeting",
    "nav.tasks": "Tugas",
    "nav.activities": "Aktivitas",
    "nav.reports": "Laporan",
    "nav.users": "Manajemen Tim",
    "nav.logout": "Keluar",
    "auth.login": "Masuk",
    "auth.email": "Email",
    "auth.password": "Kata Sandi",
    "auth.signin": "Masuk ke Akun",
    "auth.welcome": "Selamat datang kembali",
    "auth.signInDesc": "Kelola pipeline, kontak, dan tim penjualan Anda dari satu tempat.",
    "kpi.pipeline": "Nilai Pipeline",
    "kpi.won": "Nilai Won",
    "kpi.openDeals": "Deal Aktif",
    "kpi.meetings": "Meeting Minggu Ini",
    "kpi.contacts": "Total Kontak",
    "kpi.tasks": "Tugas Terbuka",
    "action.new": "Buat Baru",
    "action.newDeal": "Deal Baru",
    "action.newContact": "Kontak Baru",
    "action.newMeeting": "Jadwalkan Meeting",
    "action.newTask": "Tugas Baru",
    "action.newUser": "Tambah Anggota",
    "action.save": "Simpan",
    "action.cancel": "Batal",
    "action.delete": "Hapus",
    "action.edit": "Ubah",
    "stage.lead": "Prospek",
    "stage.quotation": "Make an Offer / Quotation",
    "stage.discuss_mgmt": "Discuss Management",
    "stage.negotiation": "Negotiation / Finalize proposal",
    "stage.invoice": "Send Invoice / Waiting Payment",
    "stage.payment": "Payment",
    "stage.pending": "Pending",
    "stage.lose": "Lose",
    "role.admin": "Administrator",
    "role.manager": "Manajer",
    "role.sales": "Sales",
    "common.name": "Nama",
    "common.value": "Nilai",
    "common.stage": "Tahap",
    "common.owner": "Pemilik",
    "common.company": "Perusahaan",
    "common.email": "Email",
    "common.phone": "Telepon",
    "common.status": "Status",
    "common.dueDate": "Jatuh Tempo",
    "common.priority": "Prioritas",
    "common.startTime": "Waktu Mulai",
    "common.endTime": "Waktu Selesai",
    "common.title": "Judul",
    "common.notes": "Catatan",
    "common.role": "Peran",
    "common.actions": "Aksi",
    "common.close": "Tutup",
    "common.search": "Cari...",
    "empty.title": "Belum ada data",
    "empty.desc": "Klik tombol di atas untuk menambahkan data pertama.",
  },
  en: {
    "app.name": "Nusacert CRM",
    "app.tagline": "ISO Sales Management",
    "nav.dashboard": "Dashboard",
    "nav.pipeline": "Pipeline",
    "nav.forecast": "Forecast",
    "nav.contacts": "Contacts",
    "nav.leadsIdle": "Idle Leads",
    "nav.meetings": "Meetings",
    "nav.tasks": "Tasks",
    "nav.activities": "Activity",
    "nav.reports": "Reports",
    "nav.users": "Team",
    "nav.logout": "Sign out",
    "auth.login": "Sign in",
    "auth.email": "Email",
    "auth.password": "Password",
    "auth.signin": "Sign in to your account",
    "auth.welcome": "Welcome back",
    "auth.signInDesc": "Manage your pipeline, contacts, and sales team from one place.",
    "kpi.pipeline": "Pipeline Value",
    "kpi.won": "Won Value",
    "kpi.openDeals": "Open Deals",
    "kpi.meetings": "Meetings This Week",
    "kpi.contacts": "Total Contacts",
    "kpi.tasks": "Open Tasks",
    "action.new": "Create New",
    "action.newDeal": "New Deal",
    "action.newContact": "New Contact",
    "action.newMeeting": "Schedule Meeting",
    "action.newTask": "New Task",
    "action.newUser": "Add Member",
    "action.save": "Save",
    "action.cancel": "Cancel",
    "action.delete": "Delete",
    "action.edit": "Edit",
    "stage.lead": "Prospek",
    "stage.quotation": "Make an Offer / Quotation",
    "stage.discuss_mgmt": "Discuss Management",
    "stage.negotiation": "Negotiation / Finalize proposal",
    "stage.invoice": "Send Invoice / Waiting Payment",
    "stage.payment": "Payment",
    "stage.pending": "Pending",
    "stage.lose": "Lose",
    "role.admin": "Administrator",
    "role.manager": "Manager",
    "role.sales": "Sales",
    "common.name": "Name",
    "common.value": "Value",
    "common.stage": "Stage",
    "common.owner": "Owner",
    "common.company": "Company",
    "common.email": "Email",
    "common.phone": "Phone",
    "common.status": "Status",
    "common.dueDate": "Due Date",
    "common.priority": "Priority",
    "common.startTime": "Start Time",
    "common.endTime": "End Time",
    "common.title": "Title",
    "common.notes": "Notes",
    "common.role": "Role",
    "common.actions": "Actions",
    "common.close": "Close",
    "common.search": "Search...",
    "empty.title": "No data yet",
    "empty.desc": "Click the button above to add your first record.",
  },
};

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("crm_lang") || "id");
  const toggle = () => {
    const next = lang === "id" ? "en" : "id";
    setLang(next);
    localStorage.setItem("crm_lang", next);
  };
  const t = (key) => (dict[lang] && dict[lang][key]) || key;
  return <I18nCtx.Provider value={{ lang, t, toggle, setLang }}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
